import React from 'react';
import Loading from "../Component/Loading"
const Blogs = () => {
    return (
        <div>
            <h1 className='font-bold text-2xl sm:text-5xl'>Coming Soon...</h1>
            <Loading></Loading>
        </div>
    );
};

export default Blogs;